import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "User ettings",
    name: "user.settings",
    path: "/app/user-settings",
  },
  {
    acl: [],
    label: "Company settings",
    name: "company.settings",
    path: "/app/company-settings",
  },
  {
    acl: [],
    label: "Notifications settings",
    name: "notifications.settings",
    path: "/app/notifications-settings",
  },
  {
    acl: [],
    label: "Followed companies",
    name: "followed.companies",
    path: "/app/followed-companies",
  },
];

export const router = routerFrom(routes);
